import { Component, Input } from '@angular/core';
import { NgClass, NgStyle } from '@angular/common';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    imports: [NgClass, NgStyle]
})
export class LoadingComponent {
    @Input() loading: boolean = false;
    @Input() pageCentered: boolean = true;
    @Input() marginTop: number = 0;
}
